import { render, staticRenderFns } from "./error-boundary.vue?vue&type=template&id=8275b7ee&scoped=true&"
import script from "./error-boundary.vue?vue&type=script&lang=js&"
export * from "./error-boundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8275b7ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8275b7ee')) {
      api.createRecord('8275b7ee', component.options)
    } else {
      api.reload('8275b7ee', component.options)
    }
    module.hot.accept("./error-boundary.vue?vue&type=template&id=8275b7ee&scoped=true&", function () {
      api.rerender('8275b7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/error-boundary/error-boundary.vue"
export default component.exports